import styled from '@emotion/styled'
import { MobileBottomNavigation } from '@hhgtech/hhg-components/components'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

export const StyledMobileBottomArticleNavigationProgress = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 3px;
  background-color: ${theme.colors.primaryBase};
  transition: width 150ms linear;
`

export const StyledMobileBottomNavigation = styled(MobileBottomNavigation)`
  ${MediaQueries.mbUp} {
    display: none !important;
  }
  border-top: 1px solid ${theme.colors.neutral100};
  &[data-template='health-tool'] {
    justify-content: space-evenly;
  }
  .mobile-navigation-icon,
  .mobile-navigation-label {
    pointer-events: none;
  }
  .mobile-navigation-label {
    width: 70px !important;
    max-width: 70px !important;
  }
  a > * {
    pointer-events: none;
  }

  .new-post {
    .mobile-navigation-icon > span {
      background-color: ${theme.colors.yellow900};
    }
  }
  > div {
    flex: 0;
  }

  .nav-item {
    position: relative;
    z-index: 1;
  }

  // &[data-has-share='true'] {
  //   padding: 0 16px;
  //   gap: 16px;
  //   .nav-item {
  //     flex: 1;
  //     .mobile-navigation-label {
  //       max-width: 100%;
  //       width: 100%;
  //     }
  //   }
  // }
`
